import { Image } from 'components/atoms';

import { Property } from 'models/properties';

interface Props {
	data: Property;
}

const PropertyInfo = (props: Props): JSX.Element => {
	const { data } = props;

	const { address, name, picture, owners, id } = data;

	const nameWithoutDash = name.replaceAll('-', ' ');
	const nameWithoutUnderscore = nameWithoutDash.replaceAll('_', ' ');

	return (
		<div className="grid grid-cols-[500px_1fr] gap-10 lg:grid-cols-1 lg:gap-[30px] md:gap-5">
			<div className="flex-shrink-0">
				<div className="mb-5 md:mb-[15px]">
					<Image src={picture} height={270} width={500} borderRadius={15} />
				</div>
				<p className="font-bold capitalize text-4xl md:text-[28px] mb-2 md:mb-1.5 text-foreground">
					{nameWithoutUnderscore}
				</p>
				<p className="text-lg md:text-base text-muted-foreground font-medium">
					{address.display}
				</p>
			</div>
		</div>
	);
};

export default PropertyInfo;
